import { render, staticRenderFns } from "./ModalCenter.vue?vue&type=template&id=ca5ae3d4&scoped=true"
import script from "./ModalCenter.vue?vue&type=script&lang=js"
export * from "./ModalCenter.vue?vue&type=script&lang=js"
import style0 from "./ModalCenter.vue?vue&type=style&index=0&id=ca5ae3d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5ae3d4",
  null
  
)

export default component.exports